import { Injectable } from '@angular/core';
import { PrintCardContentViewModel } from '../../shared/print-card-content-view-model';
import { map } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import { PrimaryCannabinoid } from '../../../../../../../models/enum/shared/cannabinoid';
import { SortUtils } from '../../../../../../../utils/sort-utils';
import { PropertyPoolSorter } from '../../shared/card-data-with-property-pooling';

@Injectable()
export class DougPostCardStackContentViewModel extends PrintCardContentViewModel {
  private readonly pinnedSecondaryPropertyMap = new Map<string, number>([
    [PrimaryCannabinoid.THC, 0],
    [PrimaryCannabinoid.CBD, 1]
  ]);

  public readonly propertiesToDisplay$ = this.propertiesBasedOnPools$;

  public readonly gridPropertiesBasedOnPools$ = this.getGridPropertiesBasedOnPools$(this.spoofedGridColViewModels$);

  public cardBodyHeight$ = this.isLineItemMode$.pipe(map(isLineItemMode => (isLineItemMode ? '19.375rem' : '15rem')));

  public gridHas3Columns$ = this.cardData$.pipe(map(cardData => cardData?.rowVariants?.length === 3));

  public readonly rightSideLineItemWidthInRem$ = combineLatest([this.isLineItemMode$, this.cardData$]).pipe(
    map(([isLineItemMode, cardData]) => {
      if (!isLineItemMode) return null;
      return cardData?.displayCannabinoidInRanges() ? 11.625 : 8.625;
    })
  );

  public readonly leftSideLineItemWidthInRem$ = this.rightSideLineItemWidthInRem$.pipe(
    map(rightSideLineItemWidthInRem => {
      const totalContentAreaWidthInRem = 34;
      const spaceBetweenLeftAndRightContentInRem = 1;
      return Number.isFinite(rightSideLineItemWidthInRem)
        ? totalContentAreaWidthInRem - spaceBetweenLeftAndRightContentInRem - rightSideLineItemWidthInRem
        : null;
    })
  );

  protected override emptyPropertyValueForPropertiesBasedOnPools(): string {
    return '-';
  }

  protected override finalSortLambdaForCompoundProperties(): PropertyPoolSorter {
    return (a, b) => SortUtils.pinned(this.pinnedSecondaryPropertyMap, a?.title, b?.title);
  }

  protected override getSecondaryPoolOfCompoundPropertiesSortLambda(): PropertyPoolSorter {
    const defaultSort = super.getSecondaryPoolOfCompoundPropertiesSortLambda();
    return (a, b) => SortUtils.pinned(this.pinnedSecondaryPropertyMap, a?.title, b?.title) || defaultSort(a, b);
  }
}
